import { Button, Spin } from "antd";
import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import appConfig from "@/config/appConfig";
import { numberFormater } from "@/utils";

const ViewPlan = () => {
  const [isLoading, setLoading] = useState(false);
  const Params = useParams();
  const planId = Params.planId;
  const [prepaidPlanDetails, setprepaidPlanDetails] = useState();
  const navigate = useNavigate();
  const getPrepaidPlan = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/subscription/` + planId, {
        withCredentials: true,
      });
      if (response) {
        setprepaidPlanDetails(response.data);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    document.title = appConfig.name + " - Edit Subscription Plan";
    getPrepaidPlan();
  }, []);
  return (
    <Spin spinning={isLoading}>
      <div className="az-content-body p-0 px-md-3">
        <div className="row row-sm mg-b-15 mg-sm-b-20">
          <div className="col-lg-12">
            <div className="card card-dashboard-six">
              <div className="card-header">
                <div className="col-md-8 p-0">
                  <label className="az-content-label">Manage Subscription Plan</label>
                  <span className="d-block py-2">Subscription Plan Details</span>
                </div>
                <div className="col-md-4 d-flex justify-content-end p-0"></div>
              </div>
              <div className="row mt-2">
                <div className="col-md-6">
                  <label className="az-content-label">General Information</label>
                  <div className="row mb-2">
                    <div className="col-5">Subscription Plan Name</div>
                    <div className="col-7">: {prepaidPlanDetails?.name || "N/A"}</div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-5">Plan Type</div>
                    <div className="col-7">: {prepaidPlanDetails?.planType || "N/A"}</div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-5">Subscription Type</div>
                    <div className="col-7">: {prepaidPlanDetails?.subscriptionType || "N/A"}</div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-5">Currency</div>
                    <div className="col-7">: {prepaidPlanDetails?.currency || "N/A"}</div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-5">Subscription Price</div>
                    <div className="col-7">
                      : {prepaidPlanDetails?.price ? numberFormater(prepaidPlanDetails?.price) : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <label className="az-content-label">Plan Limitations</label>
                  <div className="row mb-2">
                    <div className="col-5">Total Site Admin Users</div>
                    <div className="col-7">: {prepaidPlanDetails?.siteAdminCount || 0}</div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-5">Total Site Users</div>
                    <div className="col-7">: {prepaidPlanDetails?.siteUserCount || 0}</div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-5">Total Site Public Users</div>
                    <div className="col-7">: {prepaidPlanDetails?.sitePublicCount || 0}</div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-5">Total Installer Users</div>
                    <div className="col-7">: {prepaidPlanDetails?.installerCount || 0}</div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-5">Total Locations</div>
                    <div className="col-7">: {prepaidPlanDetails?.locationCount || 0}</div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-5">Total Devices</div>
                    <div className="col-7">: {prepaidPlanDetails?.deviceCount || 0}</div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-5">Total Dashboards</div>
                    <div className="col-7">: {prepaidPlanDetails?.dashboardCount || 0}</div>
                  </div>
                  {/* <div className="row mb-2">
                    <div className="col-5">Total Hosting Year</div>
                    <div className="col-7">: {prepaidPlanDetails?.storageCount || 0}</div>
                  </div> */}
                  <div className="row mb-2">
                    <label className="az-content-label d-block mt-3 mb-2">Premium Features</label>
                    <div className="col-5">Custom Reports</div>
                    <div className="col-7">: {prepaidPlanDetails?.isCustomerReportAllow ? "Yes" : "No"}</div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 d-flex justify-content-end">
                  <Link to={`/edit-plan/` + planId} className="me-1">
                    <Button type="primary">Edit</Button>
                  </Link>
                  <Button onClick={() => navigate(-1)} type="primary" className="bg-secondary">
                    Back
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default ViewPlan;
